// Marchio Neurotraining: quadrato arrotondato con tre nodi collegati.
// Lo stesso disegno è in public/favicon.svg e nelle icone dell'app.
export default function BrandLogo({ size = 28, className = '' }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary, #2f6cdf)" />
      <path d="M10 21.5 16 10.5l6 11" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 21.5h12" fill="none" stroke="#fff" strokeOpacity="0.55" strokeWidth="2.2" strokeLinecap="round" />
      <circle cx="16" cy="10.5" r="3" fill="#fff" />
      <circle cx="10" cy="21.5" r="3" fill="#fff" />
      <circle cx="22" cy="21.5" r="3" fill="#fff" />
    </svg>
  );
}
